import {
  ChangeDetectorRef,
  Directive,
  effect,
  EmbeddedViewRef,
  inject,
  Injector,
  runInInjectionContext,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[mdSignalsAutorun]',
})
export class SignalsAutorunDirective {
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly injector = inject(Injector);
  private viewRef: EmbeddedViewRef<unknown> | null = null;

  constructor() {
    this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);

    runInInjectionContext(this.injector, () => {
      effect(() => {
        this.viewRef?.detectChanges();
      });
    });
  }
}
